import { hasBusinessUnitAccess as hasBusinessUnitAccessSelector } from 'FormsUI/selectors/Scope';
export const hasBusinessUnitsAccess = state => hasBusinessUnitAccessSelector(state);